import React from "react";
import { FaCog, FaHeart } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGears, faUsers } from "@fortawesome/free-solid-svg-icons";
const WhyChooseUs = () => {
  const items = [
    {
      icon: <FontAwesomeIcon icon={faGears} />,
      title: "SUPER-FAST SUPPORT",
      description:
        "We provide fast and reliable support to ensure smooth operations for our clients",
      arcColor: "#06b6d4, #34d399",
      textColor: "text-teal-500",
      borderColor: "border-teal-500",
      iconColor: "text-teal-500",
    },
    {
      icon: <FontAwesomeIcon icon={faUsers} />,
      title: "24*7 ONLINE",
      description:
        "Our team is available around the clock to assist you with any issues, no matter the time.",
      arcColor: "#0ea5e9, #06b6d4",
      textColor: "text-sky-500",
      borderColor: "border-sky-500",
      iconColor: "text-sky-500",
    },
    {
      icon: <FaCog className="text-3xl z-10" />,
      title: " PROFESSIONAL SUPPORT",
      description:
        "This area is 100% editable. Our professional support team helps you achieve your goals with expert guidance and services.",
      textColor: "text-indigo-500",
      borderColor: "border-indigo-500",
      iconColor: "text-indigo-500",
    },
    {
      icon: <FaHeart className="text-3xl z-10" />,
      title: "Expertise & Talent",
      description:
        "A skilled and experienced team delivering tailored, high-impact solutions.",
      arcColor: "#a855f7, #ec4899",
      textColor: "text-pink-500",
      borderColor: "border-pink-500",
      iconColor: "text-pink-500",
    },
  ];

  return (
    <div className="py-12 bg-gray-50 px-8 sm:px-6 lg:px-16 text-center">
      <h6 className="text-2xl  sm:text-3xl font-bold text-main">
        WHY CHOOSE US
      </h6>
      <p className="text-gray-700 text-lg mb-10">
        Discover the values that drive our excellence and set us apart.
      </p>

      {/* <div className=" md:w-32 w-20   h-1 bg-main mx-auto mb-10 rounded-full" /> */}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-col bg-white bg-opacity-90 rounded shadow py-6 items-center"
            data-aos="fade-up"
            data-aos-delay={index * 100} // delay each card slightly
            data-aos-duration="800"
          >
            {/* Icon inside white circle with colored border */}
            <div className="relative w-24 h-24 mb-4">
              <div
                className={`w-full h-full rounded-full bg-white border-[2px] border-solid ${item.borderColor} 
          shadow-md flex items-center justify-center z-10`}
              >
                {React.cloneElement(item.icon, {
                  className: `text-3xl z-10 ${item.iconColor}`,
                })}
              </div>
            </div>

            {/* Title and Description */}
            <h3 className={`text-lg font-semibold ${item.textColor}`}>
              {item.title}
            </h3>
            <p className="text-gray-600 text-sm mt-2 px-4">
              {item.description}
            </p>
          </div>
        ))}
      </div>

      {/* <!-- From Uiverse.io by Pravins01 -->  */}
    </div>
  );
};

export default WhyChooseUs;
